// Utils
import { $qs, $qsa } from "./utils/querySelector";
import "magnific-popup";

// Blocks
import accordion from "../../templates/components/accordion";
import teaserSwitcher from "../../templates/components/teaser";
import bannerAnimation from "./banner";

// Swipers
import testimonialSlider from "../../templates/components/testimonials";
import eventsSlider from "../../templates/components/related-events";
import lightboxSlider from "../../templates/components/lightbox-grid";
import teaserSlider from "../../templates/components/teaser/teaser-swiper";
import imageSlider from "../../templates/components/image-slider";
import videoSlider from "../../templates/components/video-slider";

// Popups
import lightboxPopup from "../../templates/components/lightbox-grid/lightbox-popup";

// Nav
import menuButton from "../../templates/parts/top-nav/nav";

// Animations
import homeAnimation from "./home";
import scrollAnimations from "./scrollAnimations";
import { split } from "postcss/lib/list";
import stackingCards from "../../templates/components/stacking-cards";
import initGlobe from "./globe";

function consoleMessage() {
	console.log(
		"%cCreated by %cTWK%cwww.thewebkitchen.co.uk",
		"background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;",
		"background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;",
		"background: #FFFFFF; padding: 5px 10px;"
	);
}

function usingJS() {
	document.querySelector("html").classList.remove("no-js");
	document.querySelector("html").classList.add("js");
}

/* *********************** */
/* Start all the functions */
/* *********************** */

// Init
consoleMessage();
usingJS();

// Flexible Content
accordion();
teaserSwitcher();
stackingCards();

// Swipers
testimonialSlider();
eventsSlider();
lightboxSlider();
teaserSlider();
imageSlider();
videoSlider();

// Popups
lightboxPopup();

// Nav & banner
menuButton();
bannerAnimation();

if ($qs("body.page-template-home")) {
	homeAnimation();
}

if ($qs("body.page-template-community-globe")) {
	initGlobe();
}

scrollAnimations();

jQuery(document).ready(function ($) {
	anchorlinks: {
		$(document).on("click", ".scroll-to", function (event) {
			event.preventDefault();

			$("html, body").animate(
				{
					scrollTop: $($.attr(this, "href")).offset().top,
				},
				500
			);
		});
	}

	searchToggle: {
		$(".js-search-toggle").on("click", function (e) {
			e.preventDefault();
			$(this).toggleClass("is-active");
			if ($(this).hasClass("is-active")) {
				$(".js-search-popup").attr("data-state", "active");
			} else {
				$(".js-search-popup").attr("data-state", "inactive");
			}
		});
		$(".js-close-search").on("click", function (e) {
			e.preventDefault();
			$(".js-search-toggle").removeClass("is-active");
			$(".js-search-popup").attr("data-state", "inactive");
		});
		$(document).keydown(function (e) {
			// ESCAPE key pressed
			if (e.keyCode == 27) {
				$(".js-search-toggle").removeClass("is-active");
				$(".js-search-popup").attr("data-state", "inactive");
			}
		});
	}

	imagePopup: {
		$(".prose .gallery").magnificPopup({
			delegate: "a",
			type: "image",
			mainClass: "mfp-img-mobile",
			closeOnContentClick: true,
			image: {
				verticalFit: true,
				titleSrc: function (item) {
					return item.el.attr("title");
				},
			},
			gallery: {
				enabled: true,
			},
		});
	}

	videoPopup: {
		$('[data-name="video-popup"]').magnificPopup({
			type: "iframe",
			mainClass: "mfp-video-wrapper",
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false,

			iframe: {
				markup:
					'<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
					"</div>",
				patterns: {
					youtu: {
						index: "youtu.be",
						id: function (url) {
							// Capture everything after the hostname, excluding possible querystrings.
							var m = url.match(/^.+youtu.be\/([^?]+)/);

							if (null !== m) {
								return m[1];
							}

							return null;
						},
						// Use the captured video ID in an embed URL.
						// Add/remove querystrings as desired.
						src: "//www.youtube.com/embed/%id%?autoplay=1&rel=0",
					},
					youtube: {
						index: "youtube.com/",
						id: "v=",
						src: "https://www.youtube.com/embed/%id%?autoplay=1",
					},
					vimeo: {
						index: "vimeo.com/",
						id: function (url) {
							var m = url.match(
								/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/
							);
							if (!m || !m[5]) return null;
							return m[5];
						},
						src: "https://player.vimeo.com/video/%id%?autoplay=1",
					},
				},
			},
		});
	}

	externallinks: {
		$('a[href^="mailto:"]').each(function () {
			$(this).addClass("email-link");
		});

		$(
			'a:not(.email-link):not([class^="magnific-"]):not([data-name="video-popup"])'
		).each(function () {
			var a = new RegExp("/" + window.location.host + "/");

			if (!a.test(this.href)) {
				$(this).click(function (event) {
					event.preventDefault();
					window.open(this.href, "_blank");
				});
			}
		});
		pdfs: {
			// Open PDFs in new window
			$(function () {
				$('a[href$=".pdf"]').prop("target", "_blank");
			});
		}
	}
});

// Vanilla JS functions on page load
document.addEventListener("DOMContentLoaded", function () {
	// Add class to .button-download parent
	function addClassToButtonDownloadParent() {
		const buttons = document.querySelectorAll(".button-download");
		buttons.forEach((button) => {
			const parent = button.parentElement;
			parent.classList.add("margin-bottom-35");
		});
	}
	addClassToButtonDownloadParent();
});
